import { Utils } from "../../Utils/utils";

export class CaseQueryRequest {
  body: CaseQueryBody = new CaseQueryBody();
}

export class CaseQueryBody {
  ProcessName: string = 'DC Community Portal Case Process Wrapper WF';
  DCMethod: string = 'QUERY';
  DCLanguage: string = 'ENU';
  DCLoginName: string = '';
  DCReferenceNumber: string = '';
  DCEncryptedValue: string = '';
  PageSize: number = 10;
  StartRowNum: number = 0;
  NewQuery: boolean = true;
  DCIncomingHierarchy: CaseIncomingHierarchy = new CaseIncomingHierarchy();
}

export class CaseIncomingHierarchy {
  MessageId: string = Utils.generateUniqueId();
  IntObjectName: string = 'DC Community Portal Mediation Cases IO';
  MessageType: string = 'Integration Object';
  IntObjectFormat: string = 'Siebel Hierarchical';
  ["ListOfDC Community Portal Mediation Cases IO"]: CaseListOfCases = new CaseListOfCases();
}

export class CaseListOfCases {
  ["DC Community Portal Mediation Cases"]: MediationCase = new MediationCase();
}

export class MediationCase {
  ["DC Member Number"]?: string = '';
  ["DCNoOfDays"]?: string = '';
  ["Serial Number"]: string = '';
  ["DC Status"]?: string = '';
}

export class CaseManageRequest {
  body: CaseManageBody = new CaseManageBody();
}

export class CaseManageBody {
  ProcessName: string = 'DC Community Portal Case Process Wrapper WF';
  DCMethod: string = 'SUBMIT';
  DCLanguage: string = 'ENU';
  DCLoginName: string = '';
  DCReferenceNumber: string = '';
  DCEncryptedValue: string = '';
  DCIncomingHierarchy: CaseManageHierarchy = new CaseManageHierarchy();
}

export class CaseManageHierarchy {
  MessageId: string = Utils.generateUniqueId();
  IntObjectName: string = 'DC Community Portal Mediation Cases IO';
  MessageType: string = 'Integration Object';
  IntObjectFormat: string = 'Siebel Hierarchical';
  ["ListOfDC Community Portal Mediation Cases IO"]: CaseManageList = new CaseManageList();
}

export class CaseManageList {
  ["DC Community Portal Mediation Cases"]: CaseManageRecord = new CaseManageRecord();
}

export class CaseManageRecord {
  ["Serial Number"]: string = '';
  ["ListOfDC Community Portal Mediation Case Notes"]: CaseNotesList = new CaseNotesList();
}

export class CaseNotesList {
  ["DC Community Portal Mediation Case Notes"]: CaseNote[] = [new CaseNote()];
}

export class CaseNote {
  Id: string = '';
  Note?: string = '';
  ["DC Complainant Read Flg"]: string = '';
  ["DC Respondent Read Flg"]: string = '';
  ["Note Type"]?: string = '';
}
